export const environment = {

  production: false,
  apiUrl: 'https://sales-dev.scrapq.com/',
  API_URL: 'https://sales-dev.scrapq.com/',
  coreAPIURL: 'https://devapi.scrapq.com/restcontroller/',
};
